<template>
  <Modal v-model="modalOpened" width="400" :mask-closable="uploadStatus !== 'uploading'">
    <p slot="header">
      <Icon type="ios-cloud-upload-outline" />
      <span style="margin-left: 8px">导入账龄</span>
    </p>
    <span>如果你要导入截止2023年11月30日，请选择2023年12月</span>
    <DatePicker type="month" @on-change="changeDate('date')" v-model="fileDate" placeholder="选择年月"></DatePicker>
    <p class="tip">导入前，请选择年月以及导入类型</p>

    <input
      type="file"
      name="file"
      id="file"
      class="inputfile"
      @change="handlerUpload($event)"
      ref="inputFile"
    />
    <label style="margin-top: 12px" class="custom-file-upload" for="file">导入表格</label>
    <TimelineItem v-if="uploadStatus">
      <p class="time">4. 上传进度</p>

      <Alert :type="alertStatus" style="margin-top: 12px">
        {{
        uploadText
        }}
      </Alert>
      <Progress :percent="completeProgress" :status="progressBarStatus" />
    </TimelineItem>
    <div slot="footer">
      <Button
        :disabled="uploadStatus === 'uploading'"
        :loading="uploadStatus === 'uploading'"
        @click="modalOpened = false"
      >取消</Button>
    </div>
  </Modal>
</template>

<script>
import { baseURL } from "@/utils/axios";
import { mapActions } from "vuex";
import axios from "axios";
import dayjs from "dayjs";

export default {
  name: "ImportARTableModal",
  props: {},
  components: {},
  data() {
    return {
      modalOpened: false,
      confirmBtnLoading: false,
      importCusfile: undefined,
      completeProgress: 0,
      progressBarStatus: undefined,
      uploadStatus: undefined, // enum: [undefined, 'uploading', 'success', 'error']
      uploadText: "未上传",
      fileDate: null,
      exportItem: {
        fileYear: null,
        fileMonth: null
      }
    };
  },
  computed: {
    alertStatus: function() {
      switch (this.uploadStatus) {
        case "uploading":
          return "info";
        case "success":
          return "success";
        case "error":
          return "error";
        default:
          return "info";
      }
    }
  },
  methods: {
    async openModal(spo) {
      Object.assign(this.$data, this.$options.data());
      this.modalOpened = true;
    },
    changeDate() {
      const date = dayjs(this.fileDate)
        .format("YYYY-MM")
        .split("-");
      this.exportItem.fileYear = date[0];
      this.exportItem.fileMonth = date[1];
    },
    handlerUpload: function(e) {
      this.uploadStatus = "uploading";
      this.uploadText = "上传中...";
      this.progressBarStatus = null;

      //获取选定的文件
      this.importCusfile = e.target.files[0];
      let param = new FormData();
      param.append("file", this.importCusfile);
      // if (!this.checkFileSize(this.importCusfile.size)) {
      //   this.uploadStatus = "error";
      //   return (this.uploadText = "文件体积必须小于7M");
      // }
      if (!this.checkFileType(this.importCusfile.name.split(".")[1])) {
        this.uploadStatus = "error";
        return (this.uploadText = "只支持.xls .xlsx格式");
      }

      var that = this;
      let config = {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: e => {
          that.completeProgress = ((e.loaded / e.total) * 100) | 0;
        }
      };

      axios.interceptors.request.use(
        function(config) {
          // Do something before request is sent
          let token = localStorage.getItem("token");
          // ;
          config.headers["token"] = token;
          return config;
        },
        function(error) {
          // Do something with request error
          return Promise.reject(error.response.data);
        }
      );
      axios
        .post(
          `${baseURL}/import_ar_table?year=${this.exportItem.fileYear}&month=${this.exportItem.fileMonth}`,
          param,
          config
        )
        .then(function(response) {
          that.uploadStatus = "success";
          that.uploadText = "导入成功";
          that.$refs.inputFile.value = null;
          that.$emit("uploadSuccess");
          if (response.data.data.errorData.length > 0) {
            that.$emit("importResult", response.data.data);
          }
          that.modalOpened = false;
        })
        .catch(function(error) {
          that.uploadStatus = "error";
          that.uploadText = `上传错误：${error.response.data}`;
          that.progressBarStatus = "wrong";
          that.$refs.inputFile.value = null;
        });
    },
    formatFileSize: function(fileSize, idx) {
      var units = ["B", "KB", "MB", "GB"];
      idx = idx || 0;
      if (fileSize < 1024 || idx === units.length - 1) {
        return fileSize.toFixed(1) + units[idx];
      }
      return this.formatFileSize(fileSize / 1024, ++idx);
    },
    checkFileType: function(fileType) {
      return ["xls", "xlsx"].includes(fileType);
    },
    checkFileSize: function(fileSize) {
      return fileSize < 7 * 1024 * 1024; // 7M
    }
  },
  created() {}
};
</script>

<style scoped lang="stylus">
.inputfile
  // display: none;
  width 0.1px
  height 0.1px
  opacity 0
  overflow hidden
  position absolute
  z-index -1

.tip
  color red

.custom-file-upload
  border 1px solid rgb(220, 222, 226)
  display inline-block
  padding 6px 12px
  margin-right 12px
  cursor pointer
  font-size 12px
  border-radius 4px
  user-select none
  touch-action manipulation
  color #515a6e
  transition color 0.2s linear, background-color 0.2s linear, border 0.2s linear, box-shadow 0.2s linear, -webkit-box-shadow 0.2s linear

.inputfile + label:hover
  color #0c89f0
  border-color #0c89f0
</style>
